Vue.component('pricing', {
  template: '#pricing-template',
  data: function () {
    return {
      tabNum: 1
    }
  },
  methods: {
    setTab(num){
      this.tabNum = num;
    }
  }
})
;Vue.component('pricing-aula', {
  template: '#pricing-aula-template',
  data: function () {
    return {
      studentcount: 100,
      studentPrice: 5,
      institutionPrice: 499,
      yearly: false,
      discount: 0.02, // 2%
      months: 12,
      globalTimeout: null
    }
  },
  computed: {
    studentPriceTotal () {
      return (this.studentcount * this.studentPrice).toFixed(2)
    },
    pricePrMonth () {
      return ((this.studentcount * this.studentPrice) + this.institutionPrice).toFixed(2)
    },
    totalWithoutDiscount () {
      return (((this.studentcount * this.studentPrice) + this.institutionPrice) * this.months).toFixed(2)
    },
    totalDiscount () {
      return ((((this.studentcount * this.studentPrice) + this.institutionPrice) * this.months) * (this.discount)).toFixed(2)
    },
    totalPriceWithDiscount () {
      return (this.totalWithoutDiscount * (1 - this.discount)).toFixed(2)
    },
    discountPrice () {
      return ((this.studentPriceTotal + this.institutionPrice) * 0.25).toFixed(2)
    }
  },
  methods: {
    inputKeyUp: function () {
      var self = this
      if (this.globalTimeout != null) {
        clearTimeout(this.globalTimeout)
      }
      this.globalTimeout = setTimeout(function () {
        this.globalTimeout = null
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'aulaInputKeyUpDelay',
          'studentCount': self.studentcount
        })
      }, 4000)
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        ;
      } else {
        return true;
      }
    }
  }
})
;Vue.component('cookie-consent', {
  template: '#cookie-consent',
  data () {
    return {
      showCookieConsent: false,
      showCC: false,
      openModal: false,
      intercom: false,
      fb: false,
      ga: false
    }
  },
  methods: {
    declineAllCookies () {
      this.setLocalStorage('accept_cookies', 0)
      this.showCookieConsent = false
    },
    closeModal () {
      this.openModal = false
    },
    learnMore () {
      this.openModal = true
    },
    setSelectedCookies () {
      if (this.intercom) {
        this.acceptIntercom()
      }
      if (this.fb) {
        this.acceptFb()
      }
      if (this.ga) {
        this.acceptGa()
      }
      let cookies = {intercom: this.intercom, fb: this.fb, ga: this.ga}
      this.setLocalStorage('accept_cookies', JSON.stringify(cookies))
      this.showCookieConsent = false
    },
    acceptAllCookiesInitial () {
      this.acceptIntercom()
      this.acceptGa()
      this.acceptFb()
    },
    allCookies () {
      // this.acceptIntercom()
      // this.acceptGa()
      // this.acceptFb()
      this.showCookieConsent = false
      this.setLocalStorage('accept_cookies', 1)
    },
    acceptIntercom () {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'cookiesAcceptIntercom'
      })
      setTimeout(function () {
        document.dispatchEvent(new Event('event::acceptIntercom'))
      }, 0)
    },
    acceptGa () {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'cookiesAcceptGoogleAnalytics'
      })
      setTimeout(function () {
        document.dispatchEvent(new Event('event::acceptGa'))
      }, 0)
    },
    acceptFb () {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'cookiesAcceptFacebook'
      })
      setTimeout(function () {
        document.dispatchEvent(new Event('event::acceptGa'))
      }, 0)
    },
    setLocalStorage (name, val) {
      try {
        if (typeof (Storage) !== 'undefined') {
          window.localStorage.setItem(name, val)
        }
      } catch (e) {
        // localstorage probably not enabled
      }
    },
    getLocalStorage (name) {
      try {
        if (typeof (Storage) !== 'undefined') {
          if (window.localStorage.getItem(name) !== null) {
            return window.localStorage.getItem(name)
          }
        }
      } catch (e) {
        // localstorage probably not enabled
      }
    }
  },
  beforeMount () {
    this.acceptAllCookiesInitial()
    // No cookies accepted yet
    if (!this.getLocalStorage('accept_cookies')) {
      this.showCookieConsent = true
      setTimeout(_=> {
        this.showCC = true
      }, 3000)
    }
    /*
    switch (this.getLocalStorage('accept_cookies')) {
      case '1':
        this.acceptIntercom()
        this.acceptGa()
        this.acceptFb()
        break
      case '0':
        break
      default:
        try {
          let o = JSON.parse(this.getLocalStorage('accept_cookies'))
          if (o && typeof o === 'object') {
            if (o.intercom) {
              this.acceptIntercom()
            }
            if (o.ga) {
              this.acceptGa()
            }
            if (o.fb) {
              this.acceptFb()
            }
            return
          }
        } catch (e) {
        }
        return {}
    }
     */
  }
})
;Vue.component('signup-dk', {
  template: '#signup-dk-template',
  data: function () {
    return {
      email: '',
      emailOk: false
    }
  },
  mounted() {
    console.log('signup-dk mounted')
  },
  methods: {
    mailCheck() {
      this.emailOk = this.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) !== null
    },
    yesClick() {
      const self = this
      // Check if empty
      if (this.email.length < 1) {
        // Highlight input
        document.querySelector('.js-cta-input__input').focus()
      } else {
        //window.location = 'http://localhost:3000/signup?signup[email]=' + this.email
        window.location = 'https://app.docendo.dk/signup?signup[email]=' + this.email
        dataLayer.push({'event': 'signed-up'})
      }
    }
  }
})
;Vue.component('signup-no', {
  template: '#signup-no-template',
  data: function () {
    return {
      email: '',
      emailOk: false
    }
  },
  mounted() {
    console.log('signup-no mounted')
  },
  methods: {
    mailCheck() {
      this.emailOk = this.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) !== null
    },
    yesClick() {
      const self = this
      // Check if empty
      if (this.email.length < 1) {
        // Highlight input
        document.querySelector('.js-cta-input__input').focus()
      } else {
        // window.location = 'http://localhost:3000/signups/by_emails/new?signups_by_email[country]=no&signups_by_email[locale]=nb&signups_by_email[email]=' + this.email
        window.location = 'https://app.docendo.no/signup?signup[email]=' + this.email
        dataLayer.push({'event': 'signed-up'})
      }
    }
  }
})
;new Vue({
  el: '#app',
  data: {
    activeFeatureTab: -1,
    timer: ''
  },
  methods: {
    setActiveFeatureTab (tabNum) {
      this.activeFeatureTab = tabNum
    },
    showFeatureSlider (tabNum) {
      return this.activeFeatureTab === tabNum
    },
    isActiveFeatureTab (tabNum) {
      if (this.activeFeatureTab === -1) {
        return true
      } else {
        return this.activeFeatureTab === tabNum
      }
    },
    cardEnter (title) {
      this.timer = setTimeout(() => {
        console.log('nu', title)
      }, 1000)
    },
    cardLeave (title) {
      clearTimeout(this.timer)
    }
  },
  mounted () {
    console.log('Vue app mounted')
  }
})
;$(function () {
  $("a.js-youtube-popup").YouTubePopUp({ autoplay: 0 });
  scrollPastFold();
  loopWords();
  loopDot();
  pageView();
});

var timer = 5000;

function pageView () {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': 'pageView',
    'virtualUrl': window.location.href
  });
}

function loopWords () {
  $('.word-fade .word').each(function (i) {
    var t = $(this);
    setTimeout(function () {
      t.addClass('word-fader');
      setTimeout(function () {
        t.removeClass('word-fader');
        if (i == $('.word-fade .word').length - 1) loopWords();
        ;
      }, timer);
    }, timer * i);
  });
}

function loopDot () {
  $('.mood-board__blue').each(function (i) {
    var t = $(this);

    setTimeout(function () {
      t.addClass('word-fader');
      setTimeout(function () {
        t.removeClass('word-fader');
        if (i == $('.mood-board__blue').length - 1) loopDot();
      }, timer);
    }, timer * i);
  });
}

var scrollOnce = true;

function scrollPastFold () {
  $(window).bind('scroll', function () {
    var elHeight = $('.hero').outerHeight();
    var scroolHeight = $(window).scrollTop();
    if ((scroolHeight > elHeight) && scrollOnce) {
      dataLayer.push({'event': 'scroll-under-fold'})
      scrollOnce = false;
    }
  })
}

function toggleMenu () {
  var menu = document.getElementById('js-mobile-nav')
  if (menu.classList.contains('isActive')) {
    menu.classList.remove('isActive')
  } else {
    menu.classList.add('isActive')
  }
}

/*
document.addEventListener('touchstart', function (evt) {
  var menu = document.getElementById('dropdown')
  if (evt.target.classList.contains('js-toggle-dropdown-ipad')) {
    if (!menu.classList.contains('isActive')) {
      menu.classList.add('isActive')
    }
  } else {
    if (menu.classList.contains('isActive')) {
      menu.classList.remove('isActive')
    }
  }
})

 */
;/*
    Name: YouTubePopUp
    Description: jQuery plugin to display YouTube or Vimeo video in PopUp, responsive and retina, easy to use.
    Version: 1.0.1
    Plugin URL: http://wp-time.com/youtube-popup-jquery-plugin/
    Written By: Qassim Hassan
    Twitter: @QQQHZ
    Websites: wp-time.com | qass.im | wp-plugins.in
    Dual licensed under the MIT and GPL licenses:
        http://www.opensource.org/licenses/mit-license.php
        http://www.gnu.org/licenses/gpl.html
    Copyright (c) 2016 - Qassim Hassan
*/

(function ( $ ) {

  $.fn.YouTubePopUp = function(options) {

    var YouTubePopUpOptions = $.extend({
      autoplay: 1
    }, options );

    $(this).on('click', function (e) {

      var youtubeLink = $(this).attr("href");

      if( youtubeLink.match(/(youtube.com)/) ){
        var split_c = "v=";
        var split_n = 1;
      }

      if( youtubeLink.match(/(youtu.be)/) || youtubeLink.match(/(vimeo.com\/)+[0-9]/) ){
        var split_c = "/";
        var split_n = 3;
      }

      if( youtubeLink.match(/(vimeo.com\/)+[a-zA-Z]/) ){
        var split_c = "/";
        var split_n = 5;
      }

      var getYouTubeVideoID = youtubeLink.split(split_c)[split_n];

      var cleanVideoID = getYouTubeVideoID.replace(/(&)+(.*)/, "");

      if( youtubeLink.match(/(youtu.be)/) || youtubeLink.match(/(youtube.com)/) ){
        var videoEmbedLink = "https://www.youtube.com/embed/"+cleanVideoID+"?autoplay="+YouTubePopUpOptions.autoplay+"";
      }

      if( youtubeLink.match(/(vimeo.com\/)+[0-9]/) || youtubeLink.match(/(vimeo.com\/)+[a-zA-Z]/) ){
        var videoEmbedLink = "https://player.vimeo.com/video/"+cleanVideoID+"?autoplay="+YouTubePopUpOptions.autoplay+"";
      }

      $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content"><span class="YouTubePopUp-Close"></span><iframe src="'+videoEmbedLink+'" allowfullscreen></iframe></div></div>');

      if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ){
        setTimeout(function() {
          $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
        }, 600);
      }

      $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function(){
        $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() { $(this).remove(); });
      });

      e.preventDefault();

    });

    $(document).keyup(function(e) {

      if ( e.keyCode == 27 ){
        $('.YouTubePopUp-Wrap, .YouTubePopUp-Close').click();
      }

    });

  };

}( jQuery ));
